/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_FailInputs */

const en_rd_fail = /** @type {(inputs: Rd_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail`)
};

const id_rd_fail = /** @type {(inputs: Rd_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal`)
};

/**
* | output |
* | --- |
* | "Fail" |
*
* @param {Rd_FailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fail = /** @type {((inputs?: Rd_FailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_FailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fail(inputs)
	return en_rd_fail(inputs)
});